var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"btn-group\" role=\"group\" aria-label=\"Next action\">\n    <button class=\"select-branch btn-secondary\">Select branch</button>\n    <button class=\"add-next-node\">Add next node</button>\n    <button class=\"remove-node btn-danger\">Remove node</button>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_mode/_actions.hbs
// module id = 71
// module chunks = 0